import React from "react";

type ContainerPropsType = {
    children: any;
    isFinished: boolean;
    animationDuration: number;
};

export default function Container({
    children,
    isFinished,
    animationDuration,
}: ContainerPropsType) {
    return (
        <div
            style={{
                opacity: isFinished ? 0 : 1,
                pointerEvents: "none",
                transition: `opacity ${animationDuration}ms linear`,
            }}
        >
            {children}
        </div>
    );
}
